<template>
<div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                <span aria-hidden="true">
                    <i class="material-icons d-none d-md-inline-block">close</i>
                    <i class="material-icons d-md-none">arrow_back</i>
                </span>
            </button>
        </div>
        <div class="modal-body">
            <div class="modal-body-content">
                <h3 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">How to use the "White Label" Tool</h3>
                <img class="help-videos w-100 rounded" :src="imgPath" alt="How to White Label tool" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                imgPath: '/assets/help-videos/help-video-white-label.gif?' + new Date().getTime()
            }
        }
    }
</script>

<style lang="scss" type="text/scss">

</style>